import React from 'react';
import { useTranslation } from 'react-i18next';
import { useIsReadOnly } from '../../hooks/useIsReadOnly';

interface ProductSearchHeaderProps {
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onImportClick: () => void;
  onCreateClick: () => void;
}

export const ProductSearchHeader: React.FC<ProductSearchHeaderProps> = ({
  searchTerm,
  onSearchChange,
  onImportClick,
  onCreateClick,
}) => {
  const { t } = useTranslation('product');
  // M11b-3: advisor (read-only) sieht keine Erstell-/Import-Buttons.
  const isReadOnly = useIsReadOnly();

  return (
    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
      <h1 className="text-2xl font-semibold text-accent-ink mb-4 md:mb-0">{t('productManagement')}</h1>
      <div className="flex flex-col md:flex-row space-y-3 md:space-y-0 md:space-x-3 w-full md:w-auto">
        {/* Suchfeld */}
        <div className="relative flex-grow md:max-w-md">
          <input
            type="text"
            placeholder={t('search')}
            className="w-full pl-10 pr-4 py-2 rounded-lg border border-hairline bg-surface-raised text-primary focus:outline-none focus:ring-2 focus:ring-indigo-500"
            value={searchTerm}
            onChange={onSearchChange}
          />
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>
        
        {/* Produkt erstellen + Import — M11b-3: für advisor (read-only) ausgeblendet */}
        {!isReadOnly && (
          <>
            {/* Produkt erstellen Button */}
            <button
              className="bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
              onClick={onCreateClick}
            >
              <span className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                </svg>
                {t('createProduct')}
              </span>
            </button>

            {/* Import-Button */}
            <button
              className="bg-indigo-600 hover:bg-indigo-700 text-[#0C1322] font-medium py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              onClick={onImportClick}
            >
              <span className="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M9 19l3 3m0 0l3-3m-3 3V10" />
                </svg>
                {t('import.title')}
              </span>
            </button>
          </>
        )}
      </div>
    </div>
  );
}; 